export enum FixedValueType {
  DATA_DOMAIN = 'data-domain',
  INTEGRATION_TYPE = 'integration-type',
}
